import apiClient from './client';

export const listTimesheets = (params) => apiClient.get('/timesheets', { params }).then((r) => r.data);
export const createTimesheet = (payload) => apiClient.post('/timesheets', payload).then((r) => r.data);
export const updateTimesheet = (id, payload) => apiClient.put(`/timesheets/${id}`, payload).then((r) => r.data);
export const deleteTimesheet = (id) => apiClient.delete(`/timesheets/${id}`).then((r) => r.data);
